module.exports = __webpack_public_path__ + "img/Romantikk_Tida_og_samfunnaforholdene1.690f38d5.jpg";